// material-ui
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";

// project import
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";
import { FormattedMessage, useIntl } from "react-intl";

//import { deleteCustomer } from 'api/customer';
import { openSnackbar } from "api/snackbar";

// assets
import { DeleteFilled } from "@ant-design/icons";

// types
import { SnackbarProps } from "types/snackbar";
import { useState } from "react";
import { AXIOS } from "../../../../api/axios";

interface Props {
  id: number;
  title: string;
  open: boolean;
  handleClose: () => void;
  fetchData?: any;
  setOpen: any;
  setResult: any;
}

// ==============================|| TITLE - DELETE ||============================== //

export default function AlertStaticPageDelete({
  id,
  title,
  open,
  handleClose,
  fetchData,
  setOpen,
  setResult,
}: Props) {
  const [isDeleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await AXIOS.delete(`/pages/${id}`);
      setResult((prevResults: any[]) =>
        prevResults.filter((item) => item.id !== id)
      );
      openSnackbar({
        open: true,
        message: "Page deleted successfully",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "success",
        },
      } as SnackbarProps);
      setOpen(false);
    } catch (error) {
      console.error("Error deleting page:", error);
      openSnackbar({
        open: true,
        message: "Error deleting page",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "alert",
        alert: {
          color: "error",
        },
      } as SnackbarProps);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="column-delete-title"
      aria-describedby="column-delete-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar
            color="error"
            sx={{ width: 72, height: 72, fontSize: "1.75rem" }}
          >
            <DeleteFilled />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              <FormattedMessage id="Are you sure you want to delete" />
            </Typography>
            <Typography align="center">
              <FormattedMessage id="By deleting" />
              <Typography variant="subtitle1" component="span">
                {" "}
                "{title}"{" "}
              </Typography>
              <FormattedMessage id="all data assigned to that category will also be deleted" />
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button
              fullWidth
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              <FormattedMessage id="Cancel" />
            </Button>
            <Button
              disabled={isDeleting}
              fullWidth
              color="error"
              variant="contained"
              onClick={handleDelete}
              autoFocus
            >
              <FormattedMessage id="Delete" />
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
